import { c as _c } from "react/compiler-runtime";
import { BreadcrumbsData } from '@systemeio/ui';
import { deactivateCampaignStep, duplicateCampaignStep, editNoteCampaignStep, removeCampaignStep } from 'modules/campaigns/campaign-steps/api/campaign-step-api';
import { ActivateCampaignStepWithoutButton } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/activate-campaign-step-without-button';
import { transformCampaignStepDataToActivateData } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/utils';
import { CampaignStepLoco } from 'modules/campaigns/campaign-steps/constants/campaign-step-loco';
import { useCampaignSteps } from 'modules/campaigns/campaign-steps/hooks/use-campaign-steps';
import { useCampaignStepsStatistics } from 'modules/campaigns/campaign-steps/hooks/use-campaign-steps-statistics';
import { useCreateCampaignStep } from 'modules/campaigns/campaign-steps/hooks/use-create-campain-step';
import { CampaignStepApiInterface, CampaignStepEditErrors, CampaignStepId, CampaignStepInterface } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { getCampaignStepsEditorNextjsUrl } from 'modules/campaigns/campaign-steps/utils/get-campaign-steps-editor-nextjs-url ';
import { onMutateCampaignStepDataItem } from 'modules/campaigns/campaign-steps/utils/on-mutate-campaign-step-data-item';
import { useCampaignStepTableColumns } from 'modules/campaigns/campaign-steps/utils/use-campaign-step-table-columns';
import { EditCampaignModal } from 'modules/campaigns/components/edit-campaign-modal';
import { useGetCampaignParameters } from 'modules/campaigns/hooks/use-get-campaign-parameters';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import { getCampaignsListNextjsUrl } from 'modules/campaigns/utils/get-campaigns-list-url';
import { getEmailStatisticsUrl } from 'modules/mailing/email-statistics/utils/get-email-statistics-url';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import ConfirmationModal from 'shared/components/confirmation-modal';
import EditModal from 'shared/components/edit-modal';
import FormTextarea from 'shared/components/form-textarea';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { useRevalidateModules } from '@systemeio/util';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
const defaultErrors: CampaignStepEditErrors = {
  note: ''
};
const CampaignStep: NextPage = () => {
  const $ = _c(108);
  const router = useRouter();
  const campaignId = Number(router.query.campaignId) as CampaignId;
  const {
    pagination,
    limit
  } = usePagination();
  const [errors, setErrors] = useState(defaultErrors);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== campaignId || $[1] !== limit || $[2] !== pagination) {
    t0 = {
      limit,
      pagination,
      campaignId
    };
    $[0] = campaignId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const {
    campaignStepsData,
    mutate,
    isCampaignStepsDataValidating
  } = useCampaignSteps(t0);
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[4] !== campaignId) {
    t1 = {
      campaignId
    };
    $[4] = campaignId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    campaignParameters,
    mutateCampaignParameters
  } = useGetCampaignParameters(t1);
  let t2;
  if ($[6] !== campaignStepsData?.items) {
    t2 = campaignStepsData?.items.map(_temp);
    $[6] = campaignStepsData?.items;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== campaignId || $[9] !== t2) {
    t3 = {
      campaignId,
      campaignStepIds: t2
    };
    $[8] = campaignId;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    campaignStepsStatisticsData
  } = useCampaignStepsStatistics(t3);
  let t4;
  if ($[11] !== campaignId) {
    t4 = {
      campaignId
    };
    $[11] = campaignId;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const campaignStepTableColumns = useCampaignStepTableColumns(t4);
  let t5;
  if ($[13] !== t) {
    t5 = t("dashboard.campaign.title_plural");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = getCampaignsListNextjsUrl();
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t5) {
    t7 = {
      caption: t5,
      href: t6,
      isStatic: true
    };
    $[16] = t5;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = campaignParameters?.name || "";
  let t9;
  if ($[18] !== t8) {
    t9 = {
      caption: t8
    };
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7 || $[21] !== t9) {
    t10 = [t7, t9];
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const breadcrumbsData = t10;
  const t11 = campaignParameters?.senderEmailAddress;
  let t12;
  if ($[23] !== campaignId || $[24] !== t11) {
    t12 = {
      campaignId,
      defaultSenderEmailAddress: t11
    };
    $[23] = campaignId;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const createCampaignData = useCreateCampaignStep(t12);
  let t13;
  if ($[26] !== revalidateModules) {
    t13 = async id => {
      await removeCampaignStep(id);
      await revalidateModules([RequestModuleEnum.CampaignStep], true);
    };
    $[26] = revalidateModules;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const onRemoveCampaignStep = t13;
  let t14;
  if ($[28] !== mutate || $[29] !== revalidateModules) {
    t14 = async (id_0, newData) => {
      await fetchWithErrors(async () => {
        await editNoteCampaignStep(id_0, newData);
        await onMutateCampaignStepDataItem(mutate, id_0, newData);
        await revalidateModules([RequestModuleEnum.CampaignStep]);
      }, setErrors);
    };
    $[28] = mutate;
    $[29] = revalidateModules;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const onEditNoteCampaignStep = t14;
  let t15;
  if ($[31] !== mutate || $[32] !== revalidateModules) {
    t15 = async campaignStep => {
      await deactivateCampaignStep(campaignStep.id);
      await onMutateCampaignStepDataItem(mutate, campaignStep.id, {
        ...campaignStep,
        isActive: false
      } as CampaignStepInterface);
      await revalidateModules([RequestModuleEnum.CampaignStep]);
    };
    $[31] = mutate;
    $[32] = revalidateModules;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  const onDeactivateCampaignStep = t15;
  let t16;
  if ($[34] !== campaignId || $[35] !== revalidateModules || $[36] !== router) {
    t16 = async campaignStep_0 => {
      const response = await duplicateCampaignStep(campaignStep_0.id);
      await revalidateModules([RequestModuleEnum.CampaignStep], true);
      await router.push(getCampaignStepsEditorNextjsUrl({
        campaignId,
        campaignStepId: response.data.id
      }));
    };
    $[34] = campaignId;
    $[35] = revalidateModules;
    $[36] = router;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  const onDuplicateCampaignStep = t16;
  const [newSenderEmail, setNewSenderEmail] = useState();
  let t17;
  if ($[38] !== campaignStepsData || $[39] !== campaignStepsStatisticsData) {
    t17 = campaignStepsData && {
      hasMore: campaignStepsData?.hasMore ?? false,
      items: campaignStepsData?.items.map(i_0 => ({
        ...i_0,
        mailingDeliveryStats: campaignStepsStatisticsData ? campaignStepsStatisticsData[i_0.id] ?? null : undefined
      }) as CampaignStepInterface) ?? []
    };
    $[38] = campaignStepsData;
    $[39] = campaignStepsStatisticsData;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  const data = t17;
  const t18 = !campaignParameters;
  let t19;
  if ($[41] !== breadcrumbsData || $[42] !== t18) {
    t19 = <BreadcrumbsDashboard isFetching={t18} data={breadcrumbsData} />;
    $[41] = breadcrumbsData;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== campaignParameters || $[45] !== mutateCampaignParameters) {
    t20 = <EditCampaignModal campaignParameters={campaignParameters} mutateCampaignParameters={mutateCampaignParameters} />;
    $[44] = campaignParameters;
    $[45] = mutateCampaignParameters;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  const t21 = isCampaignStepsDataValidating ? undefined : data;
  let t22;
  if ($[47] !== t) {
    t22 = t("dashboard.campaign_step.list.table.name");
    $[47] = t;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t) {
    t23 = t("dashboard.actions.title.activate");
    $[49] = t;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== campaignId || $[52] !== newSenderEmail) {
    t24 = (opened, onClose, campaignStep_1, key) => <ActivateCampaignStepWithoutButton initialData={transformCampaignStepDataToActivateData({
      ...campaignStep_1,
      stepBefore: null
    })} key={key} withModal={true} withConfirmButton={true} isOpened={opened} onClose={async () => {
      setNewSenderEmail(undefined);
      onClose();
    }} campaignStepId={campaignStep_1.id} campaignId={campaignId} senderEmail={newSenderEmail ?? campaignStep_1.mailing.currentEmail.fromEmail} onSenderEmailChange={t25 => {
      const {
        fromEmail
      } = t25;
      return setNewSenderEmail(fromEmail);
    }} />;
    $[51] = campaignId;
    $[52] = newSenderEmail;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== t23 || $[55] !== t24) {
    t25 = {
      name: "activate",
      caption: t23,
      shouldRender: _temp2,
      onActionRender: t24
    };
    $[54] = t23;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t) {
    t26 = t("dashboard.actions.title.deactivate");
    $[57] = t;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  let t27;
  if ($[59] !== onDeactivateCampaignStep || $[60] !== t) {
    t27 = (opened_0, onClose_0, campaignStep_2, key_0) => <ConfirmationModal confirmationText={t("dashboard.campaign_step.list.status.deactivate.confirmation_dialog.body")} key={key_0} opened={opened_0} onClose={onClose_0} onConfirm={() => onDeactivateCampaignStep(campaignStep_2)} toastCaption={t("global.deactivate")} />;
    $[59] = onDeactivateCampaignStep;
    $[60] = t;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t26 || $[63] !== t27) {
    t28 = {
      name: "deactivate",
      caption: t26,
      shouldRender: _temp3,
      onActionRender: t27
    };
    $[62] = t26;
    $[63] = t27;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] !== t) {
    t29 = t("dashboard.actions.title.duplicate");
    $[65] = t;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== onDuplicateCampaignStep || $[68] !== t) {
    t30 = (opened_1, onClose_1, campaignStep_3, key_1) => <ConfirmationModal confirmationText={t("dashboard.campaign_step.duplicate_confirm")} key={key_1} opened={opened_1} onClose={onClose_1} onConfirm={() => onDuplicateCampaignStep(campaignStep_3)} toastCaption={t("global.duplicated")} />;
    $[67] = onDuplicateCampaignStep;
    $[68] = t;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t29 || $[71] !== t30) {
    t31 = {
      name: "duplicate",
      caption: t29,
      onActionRender: t30
    };
    $[70] = t29;
    $[71] = t30;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t) {
    t32 = t("dashboard.campaign_step.edit_note.action_name");
    $[73] = t;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== errors || $[76] !== onEditNoteCampaignStep || $[77] !== t) {
    t33 = (opened_2, onClose_2, campaignStep_4, key_2) => <EditModal key={key_2} fullCaption={t("dashboard.campaign_step.edit_note.modal_window_title")} instance={campaignStep_4} opened={opened_2} onClose={onClose_2} editable={[{
      field: "note",
      onRender: (value, onChange) => <FormTextarea key="campaign-step-note" onChange={e => onChange(e.target.value)} placeholder={t("dashboard.campaign_step.list.table.header.note")} value={value || ""} className="min-h-[126px]" description={errors.note} />
    }]} onEdit={editedCampaignStep => onEditNoteCampaignStep(campaignStep_4.id, editedCampaignStep)} />;
    $[75] = errors;
    $[76] = onEditNoteCampaignStep;
    $[77] = t;
    $[78] = t33;
  } else {
    t33 = $[78];
  }
  let t34;
  if ($[79] !== t32 || $[80] !== t33) {
    t34 = {
      name: "edit note",
      caption: t32,
      onActionRender: t33
    };
    $[79] = t32;
    $[80] = t33;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  let t35;
  if ($[82] !== t25 || $[83] !== t28 || $[84] !== t31 || $[85] !== t34) {
    t35 = [t25, t28, t31, t34];
    $[82] = t25;
    $[83] = t28;
    $[84] = t31;
    $[85] = t34;
    $[86] = t35;
  } else {
    t35 = $[86];
  }
  let t36;
  if ($[87] !== t) {
    t36 = t("dashboard.actions.title.stats");
    $[87] = t;
    $[88] = t36;
  } else {
    t36 = $[88];
  }
  let t37;
  if ($[89] !== t36) {
    t37 = [{
      name: "statistics",
      caption: t36,
      setHref: _temp4,
      isNext: true
    }];
    $[89] = t36;
    $[90] = t37;
  } else {
    t37 = $[90];
  }
  let t38;
  if ($[91] !== onRemoveCampaignStep) {
    t38 = {
      onChange: campaign_1 => onRemoveCampaignStep(campaign_1.id)
    };
    $[91] = onRemoveCampaignStep;
    $[92] = t38;
  } else {
    t38 = $[92];
  }
  let t39;
  if ($[93] !== t35 || $[94] !== t37 || $[95] !== t38) {
    t39 = {
      custom: t35,
      openLink: t37,
      remove: t38
    };
    $[93] = t35;
    $[94] = t37;
    $[95] = t38;
    $[96] = t39;
  } else {
    t39 = $[96];
  }
  let t40;
  if ($[97] !== campaignStepTableColumns || $[98] !== t21 || $[99] !== t22 || $[100] !== t39) {
    t40 = <Table data={t21} columns={campaignStepTableColumns} caption={t22} actions={t39} />;
    $[97] = campaignStepTableColumns;
    $[98] = t21;
    $[99] = t22;
    $[100] = t39;
    $[101] = t40;
  } else {
    t40 = $[101];
  }
  let t41;
  if ($[102] !== createCampaignData || $[103] !== data || $[104] !== t19 || $[105] !== t20 || $[106] !== t40) {
    t41 = <ListingLayout counter={false} data={data} title={t19} type="compact" createData={createCampaignData} customHeaderElement={t20}>{t40}</ListingLayout>;
    $[102] = createCampaignData;
    $[103] = data;
    $[104] = t19;
    $[105] = t20;
    $[106] = t40;
    $[107] = t41;
  } else {
    t41 = $[107];
  }
  return t41;
};
export const getServerSideProps = getBaseServerSideProps(CampaignStepLoco, 'header.top_menu.campaigns');
export default CampaignStep;
function _temp(i) {
  return i.id;
}
function _temp2(campaign) {
  return !campaign.isActive;
}
function _temp3(campaign_0) {
  return campaign_0.isActive;
}
function _temp4(campaignStep_5) {
  return getEmailStatisticsUrl(campaignStep_5.mailing.id);
}